import Sonda from '@bit/gerenciatd.utils.front-sonda';
import { createSondaContext } from './contextUtils';

export function splitAtIndex(value, index) {
  return [value.substring(0, index), value.substring(index)];
}
export const addMediaQuery = (selector, styleStr, kind = 'nodevice') => {
  let css = '';
  // 1) deciding media query
  switch (kind) {
    case 'pc': css = `${css}@media screen and (min-width: 1260px){`; break;
    case 'mobile': css = `${css}@media screen and (min-width: 0px) and (max-width: 768px) {`; break;
    case 'mobileWhenNoTablet': css = `${css}@media screen and (min-width: 0px) and (max-width: 1260px) {`; break;
    case 'nodevice': css = ''; break;
    case 'tablet':
    default: css = `${css}@media screen and (min-width: 768px) and (max-width: 1260px) {`; break;
  }
  // appending instructions
  css += `${selector} {${styleStr}}${kind === 'nodevice' ? '{' : ''}`;
  css += '}';

  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');

  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  head.appendChild(style);
}

/* it depends on full or container width */
/* it is important, know how pictures we have */
export const bannerBuildBGImg = (currentBGImg, idBanner, div2Fit, bgColor, layout) => {
  /* Adding css rules for background image media queries */
  if (div2Fit === 'container') {
    div2Fit = ' .mainContainer';
  } else {
    // carga a full es placebo
    div2Fit = '';
  }
  const node2AplyBG = `${idBanner}${div2Fit}`

  /* BACKGROUNDS AND SHADES LIMIT */
  if (currentBGImg && currentBGImg.picMobile) {
    const deviceToAttach = !currentBGImg.picTablet ? 'mobileWhenNoTablet' : 'mobile';
    const { picMobile } = currentBGImg;
    const {
      position,
      size,
      src,
    } = picMobile;
    // esta imagen al ser en movil si el div2Fit es container ni mijita tiene que ser a full
    const node2AplyBGOnMobile = `${idBanner}`;
    // cuando es full pic se deja una imagen en lugar de una iamgen de fondo

    const bgImage = `url(${src})`;

    addMediaQuery(
      `#${node2AplyBGOnMobile}`,
      `background-image: ${bgImage};
        background-size: ${size};
        background-position: ${position};`,
      deviceToAttach,
    )
  }
  if (currentBGImg && currentBGImg.picTablet) {
    const { picTablet } = currentBGImg;
    const {
      position,
      size,
      src,
    } = picTablet;
    const bgImage = `url(${src})`;

    addMediaQuery(
      `#${node2AplyBG}`,
      `background-image: ${bgImage};
      background-size: ${size};
      background-position: ${position};
      background-repeat: no-repeat;`,
      'tablet',
    );
  }

  if (currentBGImg && currentBGImg.picDesktop) {
    const { picDesktop } = currentBGImg;
    const {
      position,
      size,
      src,
    } = picDesktop;

    const bgImage = `url(${src})`;
    addMediaQuery(
      `#${node2AplyBG}`,
      `background-image: ${bgImage};
      background-size: ${size};
       background-position: ${position};`,
      'pc',
    );
    // }
  }

  /* SET DEFAULT BACKGROUND */
  if (bgColor) {
    addMediaQuery(
      `#${idBanner}`,
      `background-color: ${bgColor}`,
      'no',
    );
  }
}

export const generateBgAndProperties = (idBanner, components, layout) => {
  // Tratamiento fondo del banner
  let whereDiv2Fit = '';
  let cssbgColor = '';
  if (components && components['BgImage-1']) {
    const currentBGImg = components['BgImage-1'];
    cssbgColor = `--${currentBGImg.bgColor}`;
    whereDiv2Fit = currentBGImg.div2Fit;
    bannerBuildBGImg(currentBGImg, idBanner, currentBGImg.div2Fit, currentBGImg.bgColor, layout);
  }
  return {
    whereDiv2Fit,
    cssbgColor,
  }
}

/**
 * Comprueba si estamos dentro de horario
 * @returns {boolean}
 */
export const checkVAHour = () => {
  const date = new Date();
  const hour = date.getHours();
  return (hour >= 9 && hour < 19);
}

export const getUrlWithoutFinalBar = (url) => {
  if (url[url.length - 1] === '/') {
    return url.slice(0, url.length - 1);
  }
  return url;
}

export const mergeConfigPage = (config) => {
  let result = config.default;
  if (config[getUrlWithoutFinalBar(window.location.pathname)]) {
    result = config[getUrlWithoutFinalBar(window.location.pathname)];
  }
  return result;
}

export const getTelefonoFromProducts = (mobile, fijo) => {
  try {
    if (mobile && mobile.datosLineasAbono && mobile.datosLineasAbono.length > 0) {
      return mobile.datosLineasAbono[0].num_telefono;
    }
    if (fijo && fijo.lineasFija && fijo.lineasFija.length > 0) {
      return fijo.lineasFija[0].numComPrim;
    }
    return ''
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'getTelefonoFromProducts',
      context,
      filePath: 'utils/common',
    });
    sonda.errorMessage({ error });
    return '';
  }
}

export const setDataDataToUser = (client, mobile, fijo) => {
  try {
    const datosUsuario = {
      nombre: (client && client.name) || (client && client.adminName) || (client && client.businessName) || '',
      docNumber: (client && client.docNumber) || '',
      email: (client && client.email) || '',
      docTypeText: (client && client.docTypeText && client.docTypeText === 'Pasaporte' ? 'PASSPORT' : client.docTypeText) || '',
      telefono: getTelefonoFromProducts(mobile, fijo),
    };

    sessionStorage.setItem('datosUsuario', JSON.stringify(datosUsuario));
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'setDataDataToUser',
      context,
      filePath: 'utils/common',
    });
    sonda.errorMessage({ error });
    return null;
  }
}

export const giveRandomNumber = (min, max) => {
  return Math.floor(Math.random() * max) + min;
};

/**
 * Comprueba un array de objetos y devuelve uno aleatoriamente
 * en base al peso que se le haya asignado. Propiedad porcentaje
 * es necesaria, y al menos un elemento obviammente
 * @param {Array} multipleOptions array de objetos
 */
export const chooseOptionFromArray = (multipleOptions) => {
  try {
    if (multipleOptions.length === 1) {
      return multipleOptions[0]
    }
    const random = Math.random() * 100;
    let auxRandom = 0;
    let selectedOption = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < multipleOptions.length; i++) {
      if (parseInt(multipleOptions[i].porcentaje) + auxRandom > random) {
        selectedOption = i;
        break;
      } else {
        // eslint-disable-next-line radix
        auxRandom += parseInt(multipleOptions[i].porcentaje);
      }
    }
    return multipleOptions[selectedOption];
  } catch (e) {
    return multipleOptions[0]
  }
}

/**
 * Comprueba y desplaza el scroll hasta la zona referenciada
 * @param {Object} ref referencia en el DOM
 */
export const checkRefAndMove = (ref, delay) => {
  if (ref.current) {
    setTimeout(() => {
      ref.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }, delay);
  }
}

/**
 * Quita el - y pone la primera letra en mayuscula
 * @param {String} a un string
 */
export const splitSpaceAndFirstUpperCase = (a) => {
  const result = a.replace('-', ' ');
  return result[0].toUpperCase() + result.slice(1);
}

function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

/* Funcion que comprueba el segmento y lo retorna
 * @return segmento
 */
export const checkSegment = () => {
  try {
    let cookieNav = null;
    try {
      cookieNav = this.getCookie('SEG_NAV');
    } catch (error) {
      const sonda = new Sonda({
        processName: 'checkSegment',
        context: createSondaContext('empresas'),
        filePath: 'utils/common',
      });
      sonda.errorMessage({
        error,
        info: 'Fallo al obtener el segmento del cliente',
      });
    }
    if (cookieNav) {
      return cookieNav;
    }
    if (window.location.href.indexOf('/empresas') >= 0) {
      return 'empresas';
    } if (window.location.href.indexOf('/particulares') >= 0) {
      return 'particulares';
    }
    // DEFAULT
    return 'particulares';
  } catch (e) {
    return 'particulares';
  }
};

/**
 * Crea la estructura de informacion necesaria para obtener la campaña correspondiente al C2C
 * @returns campaign body
 */
export const createGetCampaignBody = () => {
  try {
    return {
      wbPageId:
        typeof IC !== 'undefined'
        && typeof IC.getClientIds === 'function'
        && typeof IC.getClientIds().pageId !== 'undefined'
          ? IC.getClientIds().pageId
          : 'NO IC',

      uiGaClientID: getCookie('_ga'),

      wbSessionId: getCookie('_mc_sessid'),

      uiMantixCK: getCookie('_mc_uuid'),

      scxFrontVersion: status.version,

      scxFrontHref: window.location.href,

      scxFrontTimestamp: new Date().toISOString(),

      scxFrontInterest1: null,

      scxFrontInterest2: null,

      // solo nutriremos el campo segmento en la home, donde únicamente hay conflicto.
      scxPageSegment:
        window.location.host == 'www.movistar.es'
        && window.location.pathname === '/'
          ? checkSegment()
          : null,

      experience: null,
    };
  } catch (error) {
    const sonda = new Sonda({
      processName: 'createGetCampaignBody',
      context: createSondaContext('empresas'),
      filePath: 'utils/common',
    });
    sonda.errorMessage({
      error,
      info: 'Fallo al crear el cuerpo de la peticion para la campaña',
    });
    return null;
  }
};

export const sendPostRequest = (
  url,
  data,
  ok_func,
  ko_func,
  content_type,
  timeout,
) => {
  try {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.async = 1;
    if (timeout == true) {
      xhr.timeout = 3000;
    }
    xhr.setRequestHeader('Content-Type', content_type);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          if (typeof ok_func === 'function') {
            try {
              ok_func(xhr.response);
            } catch (error) {
              const sonda = new Sonda({
                processName: 'sendPostRequestSCX',
                context: createSondaContext('empresas'),
                filePath: 'ModalAtencionEmp',
              });
              sonda.errorMessage({
                error,
                info: 'Fallo en la peticion de campaña de SCX',
              });
            }
          }
        } else if (typeof ko_func === 'function') {
          try {
            ko_func(
              `status: ${
                xhr.status
              } - statusText: ${
                xhr.statusText
              } ${
                xhr.response
              } readyState: ${
                xhr.readyState}`,
            );
          } catch (error) {
            const sonda = new Sonda({
              processName: 'sendPostRequestSCX',
              context: createSondaContext('empresas'),
              filePath: 'ModalAtencionEmp',
            });
            sonda.errorMessage({
              error,
              info: 'Fallo en la peticion de campaña de SCX',
            });
          }
        }
      }
    };
    xhr.ontimeout = function () {
      try {
        ko_func('TimeOut');
      } catch (error) {
        const sonda = new Sonda({
          processName: 'sendPostRequestSCX',
          context: createSondaContext('empresas'),
          filePath: 'utils/common',
        });
        sonda.errorMessage({
          error,
          info: 'Fallo en la peticion de campaña de SCX timeout',
        });
      }
    };
    xhr.send(data);
  } catch (error) {
    const sonda = new Sonda({
      processName: 'sendPostRequestSCX',
      context: createSondaContext('empresas'),
      filePath: 'utils/common',
    });
    sonda.errorMessage({
      error,
      info: 'Fallo en la peticion de campaña de SCX',
    });
    ko_func(error);
  }
};

/**
 * Obtiene la información de campanias del back de SCX y actualiza current_info de forma asíncrona
 * @return retorna una promesa que es resuelta al recibir la respuesta correcta del Backend.
 *
 * */
export const requestCampaignToScxBackend = (setCampaign) => {
  try {
    if (!window.scxValue) {
      sendPostRequest(
        'https://campaign.scx.col.movistar.es/scx/campaign/dispatcher/campaign',
        JSON.stringify(createGetCampaignBody()),

        // Caso OK
        (data) => {
          const jsonData = data != '' ? JSON.parse(data) : '';
          window.scxValue = jsonData.scxCampaignValue;
          setCampaign(jsonData.scxCampaignValue);
        },

        // Caso KO --> si se produce error en la propia función sendPostRequest, nos trae el error del catch, lo tratamos.
        (response) => {
          const sonda = new Sonda({
            processName: 'requestCampaignToScxBackend',
            context: createSondaContext('empresas'),
            filePath: 'utils/common',
          });
          sonda.errorMessage({
            info: `Error al obtener la campaña de scx; ${response}`,
          });
          window.scxValue = window.location.href;
          setCampaign(window.location.href);
        },
        'text/plain',
        true,
      );
    } else {
      setCampaign(window.scxValue);
    }
  } catch (error) {
    const sonda = new Sonda({
      processName: 'requestCampaignToScxBackend',
      context: createSondaContext('empresas'),
      filePath: 'utils/common',
    });
    sonda.errorMessage({
      error,
      info: 'Error al obtener la campaña de scx',
    });
  }
};
